<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string
    description?: string
  }>(),
  {
    title: 'Siap Meningkatkan Efisiensi Pengiriman Anda?',
    description:
      'Optimalkan pengiriman bisnis dengan satu integrasi AP Multi Kurir & Ekspedisi — KiriminAja'
  }
)
</script>
<template>
  <CtaSection
    :title="title"
    subtitle="Integrasi API Kurir & Ekspedisi"
    :description="description"
    class="bg-primary-container dark:bg-surface-container-high py-10 lg:py-0"
    image-class="hidden lg:block"
  >
    <template #hero>
      <NuxtImg
        alt="Integrasi API Kurir & Ekspedisi"
        src="/images/integration-api-banner-4.webp"
        class="xl:block hidden"
      />
    </template>
    <template #action>
      <div class="flex items-center gap-2 lg:gap-4 py-2">
        <UiButton
          :to="$utm.utmUrlWithCustomMetaData('/kontak-kami')"
          label="Dapatkan Demo"
        />
        <UiButton
          :to="$utm.utmUrl('https://developer.kiriminaja.com')"
          label="Lihat Dokumen API"
          target="_blank"
          variant="primaryOutline"
        />
      </div>
    </template>
  </CtaSection>
</template>
